import { render, staticRenderFns } from "./KPaginatedAutocomplete.vue?vue&type=template&id=52a654d5&"
import script from "./KPaginatedAutocomplete.vue?vue&type=script&lang=js&"
export * from "./KPaginatedAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VListItem})
